const E2E_USER_AGENT = 'e2e-test-user-agent'

export const isE2ETesting = (): boolean => {
  const userAgent =
    typeof window !== 'undefined' ? window.navigator.userAgent : ''

  if (userAgent.includes(E2E_USER_AGENT)) {
    return true
  }

  return process.env.IS_E2E_TEST === 'true'
}
